<template>
    <div class="container p-3 pb-4 margin-3 font-default-color">
        <div class="col-md-12 text-center" >
            <img class="mt-md-3 logo-size"
                 src="../assets/logo-login.png">
            <p class="text-head">
                ระบบกรอกข้อมูลชันสูตรพลิกศพ
            </p>
        </div>
        <div class="row col-md-12" style="padding: 40px 0;border-top: 1px solid #2DA1A9;margin-left: 0">
            <div class=" col-md-6 bg-default-color login-form text-center">
                <div class="font-base-color font22">เข้าสู่ระบบ</div>
                <input type="text" class="custom-input" placeholder="รหัสโรงพยาบาล" v-model="hospcodes">
                <input type="password" class="custom-input" placeholder="รหัสผ่าน" v-model="passwords">
                <div style="display: flex">
                    <div class="col-1"></div>
                    <div class="text-left col-5" style="padding-top: 1em;padding-left: 1.5em">
                        <a href="/contact_us" class="forget-pass"
                           style="font-size: 16px;text-align: center;text-decoration: underline">
                            *ลืมรหัสผ่าน?
                        </a>
                    </div>
                    <div class="text-center col-5" style="padding-bottom: 1em">
                        <a href="/register" class="forget-pass"
                           style="font-size: 16px;text-align: center;text-decoration: underline"
                           >
                            ลงทะเบียนสำหรับผู้ใช้ใหม่
                        </a>
                    </div>
                    <div class="col-1"></div>
                </div>


                <div class="pt-0 text-center">
                    <b-button @click="login" variant="light" class="w-50 font16 btn-login  font-title-color">
                        เข้าสู่ระบบ
                    </b-button>
                </div>
            </div>
<!--            <div class="col-md-6 regis-form text-center">-->
<!--                <div class="font-default-color font22">ลงทะเบียนสำหรับผู้ใช้ใหม่</div>-->
<!--                <input type="text" class="custom-input-regis" placeholder="รหัสโรงพยาบาล" v-model="hospcode">-->
<!--                <input type="text" class="custom-input-regis" placeholder="ประเภทผู้ใช้" v-model="usertype_id">-->
<!--                <input type="text" class="custom-input-regis" placeholder="อีเมล" v-model="email">-->
<!--                <input type="text" class="custom-input-regis" placeholder="เบอร์โทรศัพท์" v-model="phone_number">-->
<!--                <input type="password" class="custom-input-regis" placeholder="รหัสผ่าน" v-model="password">-->
<!--                <input type="password" class="custom-input-regis" placeholder="ยืนยันรหัสผ่าน" v-model="password_confirmation">-->
<!--                <input type="password" class="custom-input-regis" placeholder="รหัสผ่านVIP" v-model="vip_password">-->
<!--                <input type="password" class="custom-input-regis" placeholder="รหัสผ่านVIP" v-model="vip_password_confirmation">-->
<!--                <div class="pt-0 text-center">-->
<!--                    <b-button @click="register" variant="light" class="w-50 font16 btn-register font-default-color">-->
<!--                        ลงทะเบียน-->
<!--                    </b-button>-->
<!--                </div>-->
<!--            </div>-->
        </div>
        <!--    <pre class="alert-success">{{login_form}}</pre>-->
        <!--            <pre class="alert-danger">{{optionHospital}}</pre>-->
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import Multiselect from 'vue-multiselect';
    import swal from 'sweetalert2/dist/sweetalert2.min.css'

    export default {
        name: "LoginView",
        props: {
            id: {default: null}
        },
        components: {
            Multiselect
        },
        created() {


            // this.checkLogin();
        },
        computed: {
            ...mapState({
                access_token: state => state.Auth.access_token,
            })
        },
        data() {
            return {
                first_name: "",
                usertype_id : "",
                sid : "",
                phone_number: "",
                email: "",
                passwords: "",
                hospcodes: "",
                password: "",
                hospcode: "",
                vip_password: "",
                password_confirmation: "",
                vip_password_confirmation: ""
            };
        },
        methods: {
            checkLogin() {
                if (this.user_login == null) {
                    this.$router.push({
                        name: "LoginView"
                    });
                } else if (this.user_login != null) {
                    this.$router.push({
                        name: "Status"
                    });
                }
            },
            register() {
                let data = {
                    hospcode: this.hospcode,
                    usertype_id: this.usertype_id,
                    email: this.email,
                    phone_number: this.phone_number,
                    password: this.password,
                    password_confirmation: this.password_confirmation,
                    vip_password_confirmation: this.vip_password_confirmation,
                    vip_password: this.vip_password,
                };
                this.$store.dispatch("Auth/register", data).then(() => {
                    console.log(1)
                    this.goToLoginPage();
                }).catch(e => {
                    console.log(e)
                    this.showErrorFill('ข้อมูลไม่ถูกต้อง');
                });

            },
            login() {
                let data = {
                    hospcode: this.hospcodes,
                    password: this.passwords,
                };
                this.$store.dispatch("Auth/login", data)
                    .then(() => {
                    // if(!this.validPhoneNumber(this.phone_number)) {
                    //     this.showErrorFill('กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง เช่น 0102345678');
                    // } else {
                        this.goToHomePage();
                    // }
                }).catch(() => {
                    this.showErrorFill('รหัสโรงพยาบาล หรือ รหัสผ่าน ไม่ถูกต้อง');
                });
                // this.goToHomePage();
            },
            goToHomePage() {
                console.log("go to home page")
                const path = `/home`
                if (this.$route.path !== path) this.$router.push(path)
            },
            goToLoginPage() {
                const path = `/`
                if (this.$route.path !== path) this.$router.push(path)
            },

            validPass: function (password) {
                var pass = /^Sadncd\d+$/;
                if (password.match(pass)) {
                    return true;
                } else {
                    return false;
                }
            },
            validPhoneNumber: function (phone_number) {
                var re = /^[0][0-9]{9}$/;
                if (phone_number.match(re)) {
                    return true;
                } else {
                    return false;
                }
            },
            getDistricts(province) {
                if (province) {
                    this.login_form.district_id = "";
                    this.$store.dispatch('Common/setDistrict', province.code);
                }
            },
            showErrorFill(message) {
                const Toast = this.$swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                });
                Toast.fire({
                    icon: 'error',
                    title: message
                })
            },
        }
    }
</script>

<style scoped>
    .login-form {
        color: white;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 24px;
        padding: 1.5em;
    }

    .regis-form {
        padding: 1.5em;
        height: 45vh;
    }

    .forget-pass {
        color: white !important;
        text-decoration: none;
        background-color: transparent;
    }

    .text-center {
        margin: 0 auto;
        padding-top: 1em;
    }

    .btn-login {
        background: #EFEFEF;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 30px;
        font-weight: bolder;
        padding: 0.5em;
    }

    .btn-register {
        background: #EFEFEF;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 30px;
        font-weight: bolder;
        padding: 0.5em;
        margin-top: 1em;
    }

    .custom-input {
        height: calc(1.5em + 0.75rem + 2px);
        border: 1px;
        background: #FFFFFF;
        border-radius: 30px;
        margin-top: 2em;
        text-align: center;
        width: 80%;
        font-size: 14px;
    }

    .custom-input::placeholder {
        color: #9E9E9E;
        text-align: center;
    }

    .custom-input-regis {
        height: calc(1.5em + 0.75rem + 2px);
        border: 1px;
        background: #F2F2F2;
        border-radius: 30px;
        margin-top: 0.75em;
        text-align: center;
        width: 80%;
        font-size: 14px;
    }

    .custom-input-regis::placeholder {
        color: #2DA1A9;
        text-align: center;
    }

    @media only screen and (max-width: 499px) {
        .custom-input {
            background: #FFFFFF;
            border-radius: 30px;
            margin-top: 1em;
            text-align: center;
            font-size: 14px;
            width: 80%;
        }

        .custom-input::placeholder {
            color: #9E9E9E;
            text-align: center;
        }
    }
</style>
